import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import StateContext from './context/stateContext';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StateContext>
    <Router>
      <App />
    </Router>
  </StateContext>
);
